import Logger from 'services/Logger'
import { EventDoc } from 'types/api/changes'

const META_DATA_LINE = '~~~~~~'
const META_DATA_DIVIDER = '\n\n\n\n\n' + META_DATA_LINE + '\n'
export const META_DATA_LABEL = 'Internal-do-not-delete?params='
const META_DATA_REGEXP = /Internal-do-not-delete\?params=/

export interface Location {
  lat: number
  lon: number
}

export interface MetaData {
  location?: Location
  locationName?: string
  addressHash?: string
  color?: string
}

export function unPackMetaData(event?: EventDoc): MetaData | undefined {
  if (!event || (event.Notes?.length ?? 0) === 0) return undefined
  const metaDataString = getMetaDataJson(event.Notes?.[0].Note ?? '')

  if (metaDataString && event.Notes?.[0].Note.includes(META_DATA_LABEL)) {
    try {
      return JSON.parse(metaDataString) as MetaData
    } catch (e) {
      console.error('unPackMetaData: error', e)
      return undefined
    }
  }

  return undefined
}

export function updateMetaDataInNote(
  event: EventDoc,
  metaData: MetaData
): string {
  const note = clearNote(event.Notes?.[0].Note)
  return appendNoteWithMetaData(note, metaData)
}

export function appendNoteWithMetaData(
  note: string,
  metaData?: MetaData
): string {
  if (!metaData) return note

  return note + ' ' + META_DATA_LABEL + JSON.stringify(metaData)
}

export function colorFromMetaData(event: EventDoc): string | null {
  const metaData = unPackMetaData(event)
  return metaData?.color || null
}

function getMetaDataJson(note: string | null): string | null {
  if (!note || !note.includes(META_DATA_LABEL)) {
    return null
  }

  const notesData = note.split(META_DATA_REGEXP).filter(Boolean)

  if (!notesData.length) {
    return null
  }

  const metaDataString =
    notesData.length > 1
      ? notesData[1].replace(/~/g, ' ').trim()
      : notesData[0].replace(/~/g, ' ').trim()

  return note.includes(META_DATA_LABEL) ? metaDataString : null
}

export function clearNote(note: string | undefined): string {
  if (!note) return ''

  return note.includes(META_DATA_LABEL)
    ? note.split(META_DATA_REGEXP)[0].replace(/~/g, ' ').trim() + ' '
    : note.trim()
}
